import { createAsyncThunk } from "@reduxjs/toolkit";
import { fetchData } from "../../../services/apiService";
import { setScreenMode } from "./Merchant.slice";
import { showSnackbar } from "../../snackbar/Snackbar.slice";

const MERCHANT_LIST = "merchantList/list";
const TERMINAL_LIST = "terminalList/list";
const TERMINAL_DELETE = "terminalList/delete";
const TERMINAL_RETRIVE = "terminalList/retrive";
const MERCHANT_MODIFY_BILLING = "merchantList/modifyBilling";
const MERCHANT_MODIFY_WALLET_CONFIRMATION =
  "merchantList/modifyWalletConfirmation";

export const getMerchantList = createAsyncThunk(
  MERCHANT_LIST,
  async (payload, { rejectWithValue, dispatch }) => {
    try {
      const {
        token,
        acquirerId,
        isoID,
        mode,
        acquirerName,
        page,
        page_size,
        search,
        onSuccess = false,
      } = payload;
      const endpoint = `/merchant-list`;
      const data = {
        version: "04.09.01",
        acquirerID: acquirerId,
        page,
        page_size,
        ...(mode === "iso_search" && { isoID }),
        ...(search && { search }),
      };
      const headers = {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
        acquirerName: acquirerName,
        acquirerID: acquirerId,
      };

      const {
        data: {
          merchant,
          reqhashMAC,
          page: pageData,
          page_size: pageSizeData,
          total_pages,
          total_records,
        },
      } = await fetchData({ endpoint, data, headers, token });
      if (onSuccess) {
        onSuccess();
      }
      return {
        merchantList: merchant,
        reqhashMAC: reqhashMAC,
        page: pageData,
        page_size: pageSizeData,
        total_pages,
        total_records,
      };
    } catch (error) {
      console.error("Error getting merchant list thunk:", error);
      dispatch(
        showSnackbar({
          message: "Error getting merchant list data",
          severity: "error",
        })
      );
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const getTerminalList = createAsyncThunk(
  TERMINAL_LIST,
  async (payload, { rejectWithValue, dispatch }) => {
    try {
      const { token, acquirerId, merchantID, acquirerName } = payload;
      const endpoint = `/terminals-list`;
      const data = {
        version: "04.09.01",
        acquirer: { merchantID },
      };
      const headers = {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
        acquirerName: acquirerName,
        acquirerID: acquirerId,
      };

      const {
        data: { acquirer, reqhashMAC },
      } = await fetchData({ endpoint, data, headers, token });
      const {
        merchantID: merchantId,
        merchantName,
        merchantStore,
        terminals,
      } = acquirer;
      dispatch(setScreenMode("item"));
      console.log("payload ===> ", {
        terminalList: terminals,
        merchantID: merchantId,
        merchantName: merchantName,
        merchantStore: merchantStore,
        reqhashMAC: reqhashMAC,
      });

      dispatch(
        getTerminalDetails({
          token,
          acquirerId,
          merchantID,
          acquirerName,
          terminalID: terminals[0].acquirerTerminalID,
        })
      );
      return {
        terminalList: terminals,
        merchantID: merchantId,
        merchantName: merchantName,
        merchantStore: merchantStore,
        reqhashMAC: reqhashMAC,
      };
    } catch (error) {
      console.error("Error getting terminal list thunk:", error);
      dispatch(
        showSnackbar({
          message: "Error getting terminal data",
          severity: "error",
        })
      );
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const deleteTerminal = createAsyncThunk(
  TERMINAL_DELETE,
  async (payload, { rejectWithValue, dispatch }) => {
    try {
      const {
        token,
        acquirerId,
        merchantID,
        acquirerName,
        terminalIDs,
        userID,
      } = payload;
      const endpoint = `/unenrollment`;
      const data = {
        version: "04.09.01",
        acquirer: {
          merchantID,
          merchantStore: "",
          terminalID: Array.isArray(terminalIDs) ? terminalIDs : [terminalIDs],
          userID: userID || "US01primo.operator@merchantpartners.com",
          timeStamp: new Date().toISOString(),
        },
      };
      const headers = {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
        acquirerName: acquirerName,
        acquirerID: acquirerId,
      };
      await fetchData({ endpoint, data, headers, token });
      dispatch(
        getTerminalList({
          token,
          acquirerId,
          merchantID: merchantID,
          acquirerName,
        })
      );
      return;
    } catch (error) {
      console.error("Error deleting terminal thunk:", error);
      dispatch(
        showSnackbar({
          message: "Error deleting terminal",
          severity: "error",
        })
      );
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const getTerminalDetails = createAsyncThunk(
  TERMINAL_RETRIVE,
  async (payload, { rejectWithValue, dispatch }) => {
    try {
      const {
        token,
        acquirerId,
        merchantID,
        acquirerName,
        terminalID,
        mode = "add",
      } = payload;
      console.log("getTerminalDetails > payload ===> ", payload);

      const endpoint = `/terminal-details`;
      const data = {
        version: "04.09.01",
        acquirer: {
          merchantID: merchantID,
          terminalID: terminalID,
        },
      };
      const headers = {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
        acquirerName: acquirerName,
        acquirerID: acquirerId,
      };
      const { data: terminalDetails } = await fetchData({
        endpoint,
        data,
        headers,
        token,
      });

      return {
        terminalDetails: mode === "add" ? terminalDetails : null,
        ...(mode === "edit" && { terminalInfo: terminalDetails }),
      };
    } catch (error) {
      console.error("Error getting terminal details thunk:", error);
      dispatch(
        showSnackbar({
          message: "Error getting terminal details",
          severity: "error",
        })
      );
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const sendMerchantModifyBilling = createAsyncThunk(
  MERCHANT_MODIFY_BILLING,
  async (payload, { rejectWithValue, dispatch }) => {
    try {
      const { token, merchantId, allowBilling, onSuccess = false } = payload;
      const endpoint = `/merchants/billing`;
      const data = {
        version: "04.09.01",
        merchant_id: merchantId,
        allow_billing: allowBilling,
      };
      const headers = {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      };

      await fetchData({ endpoint, data, headers, token });
      dispatch(
        showSnackbar({
          message: "Billing area modified successfully",
          severity: "success",
        })
      );
      if (onSuccess) {
        onSuccess();
      }
      return { success: true };
    } catch (error) {
      console.error("Error sending merchant modify billing thunk:", error);
      dispatch(
        showSnackbar({
          message: "Billing area modification failed",
          severity: "error",
        })
      );
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const sendMerchantModifyWalletConfirmation = createAsyncThunk(
  MERCHANT_MODIFY_WALLET_CONFIRMATION,
  async (payload, { rejectWithValue, dispatch }) => {
    try {
      const {
        token,
        merchantId,
        walletValidation,
        onSuccess = false,
      } = payload;
      const endpoint = `/merchants/billing`;
      const data = {
        version: "04.09.01",
        merchant_id: merchantId,
        wallet_validation: walletValidation,
      };
      const headers = {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      };

      await fetchData({ endpoint, data, headers, token });
      dispatch(
        showSnackbar({
          message: "Wallet confirmation modified successfully",
          severity: "success",
        })
      );
      if (onSuccess) {
        onSuccess();
      }
      return { success: true };
    } catch (error) {
      console.error(
        "Error sending merchant modify wallet confirmation thunk:",
        error
      );
      dispatch(
        showSnackbar({
          message: "Wallet confirmation modification failed",
          severity: "error",
        })
      );
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);
